import { render, staticRenderFns } from "./PlanfixPacksList.vue?vue&type=template&id=b6fd2724&scoped=true&"
import script from "./PlanfixPacksList.vue?vue&type=script&lang=js&"
export * from "./PlanfixPacksList.vue?vue&type=script&lang=js&"
import style0 from "./PlanfixPacksList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PlanfixPacksList.vue?vue&type=style&index=1&id=b6fd2724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fd2724",
  null
  
)

export default component.exports